<template>
  <div>
    <!-- Componente de notificaciones -->
    <notifications></notifications>

    <base-header class="pb-6 pb-1 pt-5 pt-md-8 bg-gradient-custom" type="custom"></base-header>

    <b-container fluid class="mt--4">
      <b-row>
        <b-col>
          <b-card>
            <form @submit.prevent="modificarDatosORG">
              <b-row class="form-group">
                <label class="col-md-2 col-form-label form-control-label">ID:</label>
                <b-col md="10">
                  <base-input v-model="datosORGid" placeholder="Ingrese ID" disabled></base-input>
                </b-col>
              </b-row>
              <b-row class="form-group">
                <label class="col-md-2 col-form-label form-control-label">NOMBRE:</label>
                <b-col md="10">
                  <base-input v-model="datosORGnombre" placeholder="Ingrese Nombre"></base-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <base-button type="success" @click="modificarDatosORG" :loading="isLoading">
                    <span v-if="!isLoading">Guardar</span>
                    <span v-if="isLoading">Guardando...</span>
                  </base-button>
                  <base-button type="warning" @click="$router.push('/Org')">Cancelar</base-button>
                </b-col>
              </b-row>
            </form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <TokenExpiredModal :show="showTokenExpiredModal"> </TokenExpiredModal>
  </div>
</template>

<script>
import axios from 'axios';
import Card from '../components/Cards/Card.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseInput from '../components/Inputs/BaseInput.vue';
import TokenExpiredModal from '../components/TokenExpiredModal.vue';

export default {
  components: { Card, BaseButton, BaseInput, TokenExpiredModal },
  data() {
    return {
      datosORGid: "", // ID de la organización
      datosORGnombre: "", // Nombre de la organización
      showTokenExpiredModal:false, // Estado de carga
      isLoading: false, // Estado de carga
    };
  },
  mounted() {
    this.fetchOrganizationData(); // Cargar datos al montar el componente
  },
  methods: {
    // Obtener los datos de la organización
    async fetchOrganizationData() {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("token");
        const id = this.$route.params.id; // Obtener el ID de la ruta
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/obtenerDatosORG/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success && response.data.data) {
          const orgData = response.data.data;
          this.datosORGid = orgData.ID_ORG; // Asignar el ID
          this.datosORGnombre = orgData.NAME_ORG; // Asignar el nombre
        } else {
          this.$notifications.addNotification({
            type: 'danger', // Tipo de notificación (error)
            message: 'Error al obtener los datos de la organización',
          });
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        this.$notifications.addNotification({
          type: 'danger', // Tipo de notificación (error)
          message: 'Error al obtener los datos de la organización',
        });
      } finally {
        this.isLoading = false;
      }
    },

    // Modificar los datos de la organización
    async modificarDatosORG() {
      this.isLoading = true;
      const token = localStorage.getItem("token");

      if (!this.checkToken()) {
        this.$notifications.addNotification({
          type: 'danger', // Tipo de notificación (error)
          message: 'Token no presente. Usuario no autenticado.',
        });
        this.isLoading = false;
        return;
      }

      const datos = {
        NAME: this.datosORGnombre, // Usar el nombre actualizado
      };

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}/modificarDatosORG/${this.datosORGid}`,
          datos,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.$notifications.addNotification({
            type: 'success', // Tipo de notificación (éxito)
            message: 'Datos modificados correctamente',
          });
          this.$router.push('/Org'); // Redirigir después de la modificación
        } else {
          this.$notifications.addNotification({
            type: 'danger', // Tipo de notificación (error)
            message: response.data.message || 'Error al modificar los datos',
          });
        }
      } catch (error) {
        console.error("Error al modificar los datos:", error);
        this.$notifications.addNotification({
          type: 'danger', // Tipo de notificación (error)
          message: 'Error al modificar los datos',
        });
      } finally {
        this.isLoading = false;
      }
    },

    handleTokenExpired() {
      this.showTokenExpiredModal = true;
      setTimeout(() => {
        this.$router.push("/login");
      }, 3000);
    },

    // Verificar si el token está presente
    checkToken() {
      return localStorage.getItem("token") !== null;
    },
  },
};
</script>